export const characters_data = [
  {
    title: "eBuy",
    img: "/images/logos/ebuy_logo.png",
    id: 1,
    smallText1: "e-Commerce",
    smallText2: "Classifieds",
    icon1: "Frame",
    icon2: "Frame-1",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  },
  {
    title: "Viva Sounds",
    img: "/images/apps/viva-sounds-mock.jpg",
    id: 2,
    smallText1: "Gospel",
    smallText2: "Songs",
    icon1: "Frame-2",
    icon2: "Frame-3",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.viva_sounds",
  },
  {
    title: "Viva Meter Taxi",
    img: "/images/apps/hulu-tender-mock-2.png",
    id: 5,
    smallText1: "Green",
    smallText2: "Electric",
    icon1: "Frame-6",
    icon2: "Frame-7",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.vivaPassenger",
  },
  {
    title: "Debo",
    img: "/images/logos/debo_logo.png",
    id: 4,
    smallText1: "Finance",
    smallText2: "Banks",
    icon1: "Frame-8",
    icon2: "Frame-9",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.debo",
  },
  {
    title: "Hulu Tender",
    img: "/images/logos/hulu_tender_logo.png",
    id: 3,
    smallText1: "Tender",
    smallText2: "Business",
    icon1: "Frame-4",
    icon2: "Frame-5",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.HuluTender",
  },
];
